import ProductVariationOption from "@components/ProductPage/ProductVariations/ProductVariationOption";

const ProductVariations = ({ product }) =>
  product.configurable_options
    .map((variation) => ({
      ...variation,
      // THIS IS A TEMPORARY HOTFIX IN ORDER TO IDENTIFY
      // THE CURRENTLY SELECTED PRODUCT
      // Current product only has label, other variations
      // have full data
      values: variation.values.map((value) =>
        product.sku === value.sku
          ? {
              ...value,
              isSelected: true,
            }
          : value
      ),
    }))
    .map((variation) => (
      <div className="mb-[30px]" key={variation.attribute_code}>
        {/* TODO: Should be replaced with Heading
          Right know, Heading doesn't have the necessary consistency across the website */}
        <div className="leading-[20px] mb-[8px] text-[#737373]">
          {variation.label}
          {": "}
          <strong className="font-medium leading-[20px] text-black">
            {variation.values.filter(({ url }) => !url)[0]?.label}
          </strong>
        </div>

        {variation.values?.length > 0 && (
          <ul className="flex flex-row items-center gap-x-2 gap-y-2 overflow-x-scroll scrollbar-hide md:overflow-x-auto md:flex-wrap">
            {variation.values.map((value) => (
              <li key={value.id} className="select-none" draggable={false}>
                <ProductVariationOption item={value} />
              </li>
            ))}
          </ul>
        )}
      </div>
    ));

export default ProductVariations;
